// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { text } from '../../tokens/themeColors/text';
export var breadcrumbsColors = function(mode) {
    var tx = text(mode);
    return {
        default: {
            text: tx.primary
        },
        hover: {
            text: tx.link
        },
        previous: {
            text: tx.tertiary
        }
    };
};

//# sourceMappingURL=breadcrumbsColors.js.map